import { NotFoundRender } from '@/components/app-shell/NotFoundRender';

const NotFound = () => {
  return (
    <>
      <NotFoundRender />
    </>
  );
};

export default NotFound;
